import React, { memo } from "react";

import { QueueManagerTable } from "Components/QueueManagerTable/QueueManagerTable";
import { LiveMissionsLoader } from "Pages/LiveMissionsPage/LiveMissionsPage.loader";
import { LiveMissionsController } from "Pages/LiveMissionsPage/LiveMissionsPage.controller";

export const QueueManagerPage = memo(() => {
  return (
    <LiveMissionsLoader>
      <LiveMissionsController />
      <QueueManagerTable />
    </LiveMissionsLoader>
  );
});
